import React from "react";
import HeaderWithoutBanner from "../../organisms/HeaderWithoutBanner";
import ProductsMain from "../../organisms/ProductsMain";
import MediaQuery from "react-responsive";
import { TwitterShareButton,TwitterIcon,FacebookShareButton,FacebookIcon} from 'react-share';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import ReactGA from "react-ga4";

const WorldMobileSuitMuseum2: React.FC = () => {
  ReactGA.initialize("G-XBRWCGVCPT");
  ReactGA.send("pageview");
  const articleUrl = "https://inoue-mokei.com/products/worldmobilesuitmuseum2";
  const productImage = () => {
    return (
      <div className="product-img">
        <p>
          <img src="/img/products/c99/1_zeong_top.jpg" alt="ワールドモビルスーツミュージアム2表紙" />
        </p>
      </div>
    )};

  const productText = () =>{
    return(
      <div className="product-txt-container">
        <div className="product-txt-container-header">
          <span className="products-tag">C99@木曜 東 マ12-b</span>
          <span className="products-genre">図鑑</span>
          <span className="products-item-title">WORLD MOBILE SUIT MUSEUM Ⅱ</span>
        </div>
        <div className="content">
          <MediaQuery minDeviceWidth={481}>
            <p className="catchcopy">ジオンの名を冠しておきながら<br/>地につける足がないとは何事だ！</p>
          </MediaQuery>
          <MediaQuery maxDeviceWidth={480}>
            <p className="catchcopy">ジオンの名を<br/>冠しておきながら<br/>地につける足が<br/>ないとは何事だ！</p>
          </MediaQuery>
          <p className="summary">宇宙世紀の現場の声を妄想たっぷりに紹介するガンダム妄想ルポ図鑑の第二弾！<br />
          作家のモリナガ・ヨウさんのWORLD TANK MUSEUMをリスペクトした作品です。
          </p>
          <p>収録: RGM-79 GM /RX-75 GUNTANK / RX-77 DOM / MS-06K ZAKU CANNON / MS-18E KÄMPFER / YMS-15 GYAN / MAGELLA ATTACK / M61A5 MAIN BATTLE TANK</p>
          <p>B5フルカラー16頁</p>
          <p className="price">頒布価格: ¥500- </p>
          <p className="up-date">発行日: 2021.12.30 </p>
          <div className="share">
            <TwitterShareButton title="WORLD MOBILE SUIT MUSEUM Ⅱ | イノウエ模型" via="inoue_mokei" url={articleUrl}>
              <TwitterIcon size={32} round/>
            </TwitterShareButton>
            <FacebookShareButton url={articleUrl}>
              <FacebookIcon size={32} round />
            </FacebookShareButton>
          </div>
          <ImageGallery items={images} showFullscreenButton={false} autoPlay slideInterval={8000}/>
        </div>
      </div>
    )};

  const images = [
    {
      original: "/img/products/c99/1_zeong_500.jpg",
      thumbnail: '/img/products/c99/1_zeong_150.jpg',
      description: "sample", 
    },
    {
      original: "/img/products/c99/5_tobira_500.jpg",
      thumbnail: '/img/products/c99/5_tobira_150.jpg',
      description: "sample",
    },
    {
      original: "/img/products/c99/7_guntank_500.jpg",
      thumbnail: '/img/products/c99/7_guntank_150.jpg',
      description: "sample",
    },
    {
      original: "/img/products/c99/9_zakucannon_500.jpg",
      thumbnail: '/img/products/c99/9_zakucannon_150.jpg',
      description: "sample",
    },
    {
      original: "/img/products/c99/13_61type_500.jpg",
      thumbnail: '/img/products/c99/13_61type_150.jpg',
      description: "sample",
    }
  ]

  return (
    <div>
      <HeaderWithoutBanner />
      <div id="main">
        <div className="container">
          <section>
            <header className="news-head">
              <span className="icon-HP-">
                <span className="path3" />
              </span>
              <span>Products</span>
            </header>
          </section>

          <MediaQuery minDeviceWidth={481}>
            <ProductsMain isFlex={true}>
              {productImage()}
              {productText()}
            </ProductsMain>
          </MediaQuery>
          <MediaQuery maxDeviceWidth={480}>
            <ProductsMain isFlex={false}>
              {productImage()}
              {productText()}
            </ProductsMain>
          </MediaQuery>
        </div>
      </div>
    </div>
  );
};

export default WorldMobileSuitMuseum2;
